import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";

import { GridColDef } from "@mui/x-data-grid";

export const useProductsColumns = () => {
  const navigate = useNavigate();

  const columns: GridColDef<{ id: number; productName: string }[][number]>[] = [
    {
      field: "productName",
      headerName: "Product Name",
      flex: 1,
      renderCell: ({ row }) => {
        const location = `/catalog/product/product/${row.id}`;

        return (
          <Link
            href={location}
            underline="none"
            onClick={(event) => {
              event.preventDefault();

              navigate(location);
            }}
          >
            {row.productName}
          </Link>
        );
      },
    },
  ];

  return columns;
};
